module.exports = __webpack_public_path__ + "img/u4380.a19f090c.svg";